module.exports = __webpack_public_path__ + "img/carbon3.a56fe76a.png";